import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormField, useFormIsValid } from '../form';
import Upload from './Upload';
import {
  required1Document,
  requireMultiDocuments,
} from '../../lib/validations';
import {
  CANDIDATE_STORY_FORM_NAME,
  DISPUTE_FORM_NAME,
  MAX_FILE_SIZE,
  VERIFICATION_FORM_NAME,
} from '../../constants';

const documentsOptional = context => {
  return [
    'disputes',
    'comments',
    'candidate-stories',
    'candidate-explanation',
  ].includes(context);
};

const documentsMultiDoc = context => {
  return ['multi-documents'].includes(context);
};

const formNameFor = context => {
  if (context === 'verifications' || context === 'candidate-explanation') {
    return VERIFICATION_FORM_NAME;
  }
  if (context === 'candidate-stories') return CANDIDATE_STORY_FORM_NAME;
  return DISPUTE_FORM_NAME;
};

const UploadButton = ({
  buttonClass,
  name,
  context,
  hideIcon,
  icon,
  buttonText,
  fileOptions,
  disabled,
  kind,
  handleUploadSuccess,
  shouldSubmit,
}) => {
  const isValid = useFormIsValid(formNameFor(context));
  const buttonOptions = {};
  const requireMultiDocs = useMemo(
    () => requireMultiDocuments(shouldSubmit),
    [shouldSubmit],
  );

  if (documentsOptional(context)) {
    buttonOptions.buttonText = 'buttons.addDocument';
    buttonOptions.validate = [];
  } else if (documentsMultiDoc(context)) {
    buttonOptions.buttonText = 'buttons.addDocument';
    buttonOptions.validate = [requireMultiDocs];
  } else {
    buttonOptions.buttonText = isValid
      ? 'buttons.uploadMore'
      : 'buttons.uploadNow';
    buttonOptions.validate = [required1Document];
  }

  if (buttonText) {
    buttonOptions.buttonText = buttonText;
  }

  return (
    <FormField
      type='upload'
      name={name}
      icon={hideIcon ? null : icon}
      buttonClass={buttonClass}
      buttonText={buttonOptions.buttonText}
      component={Upload}
      kind={kind}
      options={{ maxSize: MAX_FILE_SIZE, ...fileOptions }}
      validate={buttonOptions.validate}
      disabled={disabled}
      handleUploadSuccess={handleUploadSuccess}
    />
  );
};

UploadButton.propTypes = {
  buttonClass: PropTypes.string,
  name: PropTypes.string.isRequired,
  context: PropTypes.oneOf([
    'verifications',
    'candidate-stories',
    'disputes',
    'comments',
    'candidate-explanation',
    'multi-documents',
  ]).isRequired,
  hideIcon: PropTypes.bool,
  icon: PropTypes.string,
  buttonText: PropTypes.string,
  fileOptions: PropTypes.object,
  disabled: PropTypes.bool,
  kind: PropTypes.string,
  handleUploadSuccess: PropTypes.func,
  shouldSubmit: PropTypes.bool,
};

UploadButton.defaultProps = {
  hideIcon: false,
  icon: 'CloudUpload',
  buttonText: '',
  fileOptions: {},
  disabled: false,
  kind: 'primary',
  handleUploadSuccess: null,
  shouldSubmit: false,
};

export default UploadButton;
